import getDarkModeColors from "../../services/style-service/darkModeColors";
import { colors } from "../../consts";

const WHITE_RAISIN_100 = getDarkModeColors(colors.WHITE, colors.RAISIN_100);

const RAISIN_100_WHITE = getDarkModeColors(colors.RAISIN_100, colors.WHITE);
const RAISIN_100_RAISIN_20 = getDarkModeColors(colors.RAISIN_100, colors.RAISIN_20);
const RAISIN_100_RAISIN_40 = getDarkModeColors(colors.RAISIN_100, colors.RAISIN_40);
const RAISIN_100_ISABELLINE = getDarkModeColors(colors.RAISIN_100, colors.ISABELLINE);
const RAISIN_100_IRON = getDarkModeColors(colors.RAISIN_100, colors.IRON);
const RAISIN_80_RAISIN_20 = getDarkModeColors(colors.RAISIN_80, colors.RAISIN_20);
const RAISIN_70_RAISIN_40 = getDarkModeColors(colors.RAISIN_70, colors.RAISIN_40);
const RAISIN_20_RAISIN_80 = getDarkModeColors(colors.RAISIN_20, colors.RAISIN_80);
const RAISIN_50_TURQUOISE_100 = getDarkModeColors(colors.RAISIN_50, colors.TURQUOISE_100);
const RAISIN_50_RAISIN_80 = getDarkModeColors(colors.RAISIN_50, colors.RAISIN_80);
const RAISIN_20_TURQUOISE_100 = getDarkModeColors(colors.RAISIN_20, colors.TURQUOISE_100);

const RAISIN_80_ISABELLINE_DARKER = getDarkModeColors(colors.RAISIN_80, colors.ISABELLINE_DARKER);
const ISABELLINE_DARKER_RAISIN_80 = getDarkModeColors(colors.ISABELLINE_DARKER, colors.RAISIN_80);

const ISABELLINE_DARK_RAISIN = getDarkModeColors(colors.ISABELLINE, colors.DARK_RAISIN);
const ISABELLINE_RAISIN_100 = getDarkModeColors(colors.ISABELLINE, colors.RAISIN_100);

const IRON_RAISIN_80 = getDarkModeColors(colors.IRON, colors.RAISIN_80);

const EMPEROR_WHITE = getDarkModeColors(colors.EMPEROR, colors.WHITE);

const MINE_TURQUOISE_100 = getDarkModeColors(colors.MINE, colors.TURQUOISE_100);

const darkModeColors = {
  WHITE_RAISIN_100,
  RAISIN_100_WHITE,
  RAISIN_100_RAISIN_20,
  RAISIN_100_RAISIN_40,
  RAISIN_100_ISABELLINE,
  RAISIN_100_IRON,
  RAISIN_80_RAISIN_20,
  RAISIN_70_RAISIN_40,
  RAISIN_20_RAISIN_80,
  RAISIN_50_TURQUOISE_100,
  RAISIN_50_RAISIN_80,
  RAISIN_20_TURQUOISE_100,
  RAISIN_80_ISABELLINE_DARKER,
  ISABELLINE_DARKER_RAISIN_80,
  ISABELLINE_DARK_RAISIN,
  ISABELLINE_RAISIN_100,
  IRON_RAISIN_80,
  EMPEROR_WHITE,
  MINE_TURQUOISE_100
};

export default darkModeColors;
